/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-20 11:14:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-16 16:11:16
 * @FilePath: /src/app/payment/components/PaymentMethod/components/KlarnaAdyen/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { adyenKlarnaSession, afterpayPayDetail } from '@/api/pay';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { useImperativeHandle } from 'react';

interface KlarnaAdyenProps {
  ref: React.RefObject<any>;
  klarnaEssentialInfo: any;
  payFail: () => void;
  paySuccess: () => void;
}

export default function KlarnaAdyen({
  ref,
  children,
  ...props
}: KlarnaAdyenProps & { children?: React.ReactNode }) {
  const payAction = async (order) => {
    const params = {
      order_id: order.order_id,
      payment_method: JSON.stringify({
        type: props.klarnaEssentialInfo?.type || env.NEXT_PUBLIC_KLARNA_TYPE,
        subtype: 'sdk',
      }),
      payment_type: 'klarna_adyen',
    };

    try {
      const res: any = await adyenKlarnaSession(params);
      const paymentMethodCategories = res.data.action.sdkData.payment_method_category;

      if (!res.data.action.sdkData.client_token) {
        props.payFail();
        return;
      }
      logger.log(window.Klarna, 'window.Klarna');
      window.Klarna &&
        window.Klarna.Payments.init({
          client_token: res.data.action.sdkData.client_token,
        });
      authorizeKlarnaPayment(paymentMethodCategories, res);
    } catch (error) {
      logger.log('error', error);
      props.payFail();
    }
  };
  // 暴露给父组件
  useImperativeHandle(ref, () => ({
    payAction,
  }));

  const authorizeKlarnaPayment = async (paymentMethodCategories: any, klarnaRes: any) => {
    try {
      const authorizeResult: any = await new Promise((resolve, reject) => {
        window.Klarna &&
          window.Klarna.Payments.authorize(
            {
              payment_method_category: paymentMethodCategories,
              instance_id: '123',
            },
            {},
            (res) => {
              if (res.show_form && res.approved) {
                resolve(res);
              } else {
                reject(new Error('授权失败'));
              }
            },
          );
      });
      const params = {
        paymentData: klarnaRes.data.action.paymentData,
        klarnaToken: authorizeResult.authorization_token,
      };

      await afterpayPayDetail(params);
      props.paySuccess();
    } catch (error) {
      logger.log('error', error);
      props.payFail();
    }
  };

  return (
    <>
      <div id="klarna-payments-box" className="opacity-0" />
      {children && children}
    </>
  );
}
